import {Avatar, DataStatus, Status} from 'platform/components';
import {Heading, HStack, Show, Text, VStack} from 'platform/foundation';

import {useGetVehicleActivityListQuery} from '@dms/api/sales';
import {
  ActivityDate,
  getActivityIconColor,
  transformActivityItem,
} from '@dms/features/activity-panel';
import i18n from '@dms/i18n';

interface AuctionHistoryProps {
  vehicleId: string;
}

export function AuctionHistory(props: AuctionHistoryProps) {
  const {data, isLoading, isError} = useGetVehicleActivityListQuery({vehicleId: props.vehicleId});
  const activities =
    data?.flatMap((item) => {
      const transformed = transformActivityItem(item);
      return transformed ? [{item, transformed}] : [];
    }) ?? [];

  return (
    <DataStatus isLoading={isLoading} isError={isError}>
      <Show when={activities.length > 0}>
        <VStack spacing={0}>
          {activities.map(({item, transformed}) => (
            <HStack key={item.id} spacing={2} data-testid="activity-item">
              <Avatar
                color={transformed.color}
                icon={transformed.icon}
                iconColor={getActivityIconColor(transformed.color)}
                variant="square"
              />
              <HStack width="100%" justify="space-between" align="flex-start">
                <VStack spacing={1}>
                  <Heading size={5}>{transformed.title}</Heading>
                  <Text color="tertiary" size="xSmall">
                    {transformed.userName}
                  </Text>
                </VStack>
                <ActivityDate timestamp={item.timestamp} />
              </HStack>
            </HStack>
          ))}
        </VStack>
      </Show>
      <Show when={!isLoading && !isError && activities.length === 0}>
        <Status headline={i18n.t('general.labels.noData')} />
      </Show>
    </DataStatus>
  );
}
